"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    email: function () {
        return /(?=^[a-z0-9@.!#$%&'*+/=?^_‘{|}~-]{6,100}$)(?=^[a-z0-9.!#$%&'*+/=?^_‘{|}~-]{1,64}@)^[a-z0-9!#$%&'*+/=?^_‘{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_‘{|}~-]+)*@((?!-)[a-zA-Z0-9-]{0,62}[a-zA-Z0-9]\.)+[a-zA-Z]{2,63}$/gi;
    }
};
